<template>
  <div>
    <wc-data-box
      :title='header.title'
      :titleIcon='header.icon'
      :titleIconColor='header.iconColor'
      showEdit
      @edit='editClient'
    >
      <wc-two-column-table :items='basics'></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='header.title'
      :icon='header.icon'
      :iconColor='header.color'
      :disableButtons='!isFormValid || isLoading'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid' ref='form'>
        <basics-form v-model='clientCopy' @loading='setLoading'></basics-form>
      </v-form>
      <template v-slot:dialog-actions>
        <v-btn v-if='!isFormValid' class='primary--text' small text @click='validateForm'>Why can't I save?</v-btn>
      </template>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import BasicsForm from '@/modules/clients/components/forms/BasicsForm'

export default {
  name: 'client-basics',
  props: {
    client: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    clientCopy: {},
    showDialog: false
  }),
  computed: {
    ...mapState({
      header: state => state.icons.dataBox.basics
    }),
    basics () {
      let table = [
        { text: 'Name', value: this.client.name_display },
        { text: 'Email', value: this.client.email },
        { text: 'Snail Mail Only?', value: this.$options.filters.trueFalse(this.client.snail_mail_only) }
      ]
      if (this.client.is_company) {
        table.push({ text: 'Phone', value: this.client.work_phone })
        table.push({
          text: 'Main Contact',
          value: this.client.main_contact ? this.client.main_contact_obj.name_display : "",
          route: this.client.main_contact ? { name: 'ClientOverview', params: { id: this.client.main_contact } } : null })
        table.push({
          text: 'AP Contact',
          value: this.client.ap_contact ? this.client.ap_contact_obj.name_display : "",
          route: this.client.ap_contact ? { name: 'ClientOverview', params: { id: this.client.ap_contact } } : null })
      } else {
        table.push({ text: 'Home Phone', value: this.client.home_phone })
        table.push({ text: 'Cell Phone', value: this.client.cell_phone })
        table.push({ text: 'Work Phone', value: this.client.work_phone })
        table.push({ text: 'Work Phone Ext.', value: this.client.work_phone_extension })
        table.push({
          text: 'Works for',
          value: this.client.works_for ? this.client.works_for_obj.name_display : "",
          route: this.client.works_for ? { name: 'ClientOverview', params: { id: this.client.works_for } } : null })
      }
      return table
    }
  },
  methods: {
    editClient () {
      this.clientCopy = _.cloneDeep(this.client)
      this.showDialog = true
    },
    save () {
      if (!this.clientCopy.work_phone) {
        // since using an expand panel in the form, need to zero the extension if the work number gets deleted. - MJ
        this.clientCopy.work_phone_extension = null
      }
      this.$emit('update', this.clientCopy)
      this.showDialog = false
    },
    setLoading(val) {
      this.isLoading = val
    },
    validateForm() {
      this.$nextTick(() => {
        this.$refs.form.validate()
      })
    }
  },
  components: {
    'basics-form': BasicsForm
  }
}
</script>
